import purchaseView from '../../../../components/reimbursement/purchaseView'
import PublicBuill from '../../../../components/reimbursement/js/publicBuill'
import axios from 'axios'

export default {
  name: 'ContractProfitQuery',
  components: {
    purchaseView
  },
  data() {
    return {
      treeData: [{
        label: '全部',
        children: [
        ]
      }],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      queryData: {
        hth: ''
      },
      tableData: [],
      currentPage: 1,
      total: 0,
      limit: 200,
      documentType: 'all',
      role: '',
      dialogTitle: '',
      cnConfirm: {
        zffs: '',
        ph: ''
      },
      rowData: {},
      /* 查看组件 */
      purchaseShow: false,
      sumArr: ['合计', '', '', '1', '', '', '', '', '', '']


    }
  },
  updated() {
    this.$nextTick(() => {
      this.$refs['cnTatel'].doLayout()
    })
  },
  created() {
    PublicBuill.setThis(this)
    this.findPage()
  },
  methods: {
    Nindex(index) {
      const page = this.currentPage
      const pageSize = this.limit
      return index + 1 + (page - 1) * pageSize
    },
    /* 查询列表数据 */
    findPage() {
      const loading = this.$loading({
        lock: true,
        text: '查询中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const data = {
        hth: this.queryData.hth ? this.queryData.hth : null,
        limit: this.limit,
        currentPage: this.currentPage
      }
      this.$post('/fesback/costContract/list.z', data).then(request => {
        PublicBuill.purchaseJeFormatter(request.data.data)
        this.tableData = request.data.data
        this.total = request.data.count
        loading.close()
      }).catch(res => {
        loading.close()
        this.$message.error(res)
      })

    },
    /* 分页 */
    handleSizeChange(val) { // 每页多少条
      this.limit = val
      this.findPage()
    },
    handleCurrentChange(val) { // 当前页
      this.currentPage = val
      this.findPage()
    },
    view(index, row) {
      const loading = this.$loading({
        lock: true,
        text: '查询中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.rowData = row
      this.purchaseShow = true
      setTimeout(function a() {
        loading.close()
      }, 3000)
    },
    rqFormatter(row, column, cellValue, index) {
      const arr = row.rq.split('.')
      return arr[0]
    },
    getSummaries(param) {
      return this.sumArr
    },
    exportToBePaid() {
      const loading = this.$loading({
        lock: true,
        text: '请稍等',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const data = {
        gys: this.queryData.gys ? this.queryData.gys : null,
        lrrname: this.queryData.jbr ? this.queryData.jbr : null,
        dycs: this.queryData.dycs > 0 ? this.queryData.dycs : null,
        dycsItem: this.queryData.dycs === '0' ? 0 : null,
        settleMode: this.queryData.settleMode === '' ? null : this.queryData.settleMode,
        documentType: this.queryData.roles
      }
      axios.post(
        '/fesback/purchase/exportPurchase.z',
        data,
        {
          responseType: 'blob'
        }
      ).then(res => {
        loading.close()
        const fileName = '待支付采购付款单据' + '.xlsx'
        const blob = new Blob([res.data], { type: 'application/octet-stream' })
        const a = document.createElement('a')
        const href = URL.createObjectURL(blob)
        a.href = href
        a.setAttribute('download', fileName)
        a.click()
        URL.revokeObjectURL(href)
      })
    }
  }
}
